// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Variables, VariablesType } from 'constants/vacancy'

export const substituteVariables = (
  template: string,
  variables: VariablesType
): string => {
  return template.replace(
    /\{\{(\w+)\}\}/g,
    (match, p1: keyof VariablesType) => {
      return variables[p1] || match
    }
  )
}
